import * as Sentry from '@sentry/react';
import React, { type PropsWithChildren } from 'react';

import ErrorComponent from './ErrorComponent';

const FallbackFunction = ({ eventId }: { eventId: string | null }): React.ReactElement => (
  <ErrorComponent eventId={eventId} />
);

const ErrorBoundary: React.FC<PropsWithChildren> = ({ children }) => (
  <Sentry.ErrorBoundary fallback={FallbackFunction} showDialog={true}>
    {children}
  </Sentry.ErrorBoundary>
);

export default ErrorBoundary;
